'use-client';

import { useEffect, useRef, useState } from 'react';
import { getHistoryFromLocalStorage, saveHistoryItemToLocalStorage } from './use-nav-history';

/**
 * Same as useNavHistory, but not used router
 * @param pathname
 * @returns
 */
export function useAppNavHistory(pathname: string) {
  const [history, setHistory] = useState<string[]>(getHistoryFromLocalStorage());
  const hasPathChanged = useRef(false);

  useEffect(() => {
    if (hasPathChanged.current) {
      saveHistoryItemToLocalStorage(pathname);
      setHistory(getHistoryFromLocalStorage());
    } else {
      hasPathChanged.current = true; // Ignore the first render
    }
  }, [pathname]);

  return history;
}
